
import AssessScrollTab from '~/components/producet-scence/assess-scroll-tab.vue'
import Online from '~/components/producet-scence/online.vue'
import AssessComment from '~/components/producet-scence/assess-comment.vue'
import ThreeStep from '~/components/producet-scence/three-step.vue'
import AssessFoot from '~/components/producet-scence/assess-foot.vue'
import { getNumber } from '~/api/scence/index.js'
export default {
  name: 'Assess',
  components: {
    AssessScrollTab,
    Online,
    AssessComment,
    ThreeStep,
    AssessFoot,
  },
  layout: 'scence-single',
  data() {
    return {
      total: 0,
      weiXinUrl: '',
      nexturl: '/create/scene/create-template/?scene=assess',
    }
  },
  fetchOnServer: false,
  async fetch() {
    const res = await getNumber()
    if (res && res.data && res.data.data) {
      this.total = res.data.data
    } else {
      this.total = 1424886
    }
  },
  head: {
    title: '考试题库-在线考试-在线组卷-备课组卷-选题出卷-问卷网',
    link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/assess/' }],
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '在线组卷、在线测评、在线考试、在线作业、轻松创建在线考试，问卷网',
      },
      {
        hid: 'description',
        name: 'description',
        content:
          '问卷网(www.wenjuan.com)拥有内容丰富的题目，由各种真实题目合成的题库，拥有上万条初高中题库，提供英语考试、语文考试、数学考试、生物考试、作业、日日练、阶段练习等各种考试，可创建作业、课后练习、员工考核、培训考试、招聘考试、知识竞赛等场景场景，轻松创建在线考试、在线测评等',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
      },
    ],
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
  },
  mounted() {
    this.setRegisterConfig()
    setTimeout((_) => {
      this.$nuxt.refresh()
    }, 3000)
  },
  methods: {
    // 设置登入配置
    setRegisterConfig() {
      // 改变登入首页的回调地址
      this.$store.commit('setLoginStatus', {
        nexturl: this.nexturl,
      })
    },
    handLogin() {
      if (!this.isMobile)
        return this.$store.commit('setLoginStatus', {
          show: true,
        })
      this.$href('/m/login/?quicklogin=1&emailorusername=&vvv=16728549930973728')
    },
  },
}
